<div class="org-index-comp">
  <ng-container *ngIf="organisation$ | async as organisation; else loading">
    <div class="w-100 flex-column">
      <nw-header></nw-header>
      <div class="flex-column h-100 stretch position-relative">
        <!-- <div class="side-bar h-100"> -->
        <div
          class="header h-100 position-absolute flex-column space-between stretch"
          style="z-index: 1000; top: 0; bottom: 0; left: 0; right: 0"
        >
          <div>
            <div class="title">{{ organisation.name }}</div>
            <div class="menu flex-column text-center">
              <div
                class="menu-item"
                [class.menu-item-selected]="isProjectsMode"
                (click)="selectMode()"
              >
                Projects
              </div>
              <div
                class="menu-item"
                [class.menu-item-selected]="isUsersMode"
                (click)="selectMode('users')"
              >
                Users
              </div>
              <div
                class="menu-item"
                [class.menu-item-selected]="isSettingsMode"
                (click)="selectMode('settings')"
              >
                Settings
              </div>
            </div>
          </div>
          <div class="exit" routerLink="">
            <div>Exit</div>
          </div>
        </div>

        <div class="body w-100 h-100">
          <nw-project-selector
            *ngIf="isProjectsMode"
            [organisationId]="organisation.id"
            [editable]="true"
          ></nw-project-selector>
          <nw-user-selector
            *ngIf="isUsersMode"
            [organisationId]="organisation.id"
            [editable]="true"
          ></nw-user-selector>
          <div
            *ngIf="isSettingsMode"
            style="margin-top: 48px"
            class="flex-row space-around"
          >
            <nw-org-color-palette-edit></nw-org-color-palette-edit>
          </div>
        </div>
      </div>
    </div>
  </ng-container>

  <ng-template #loading>
    <div class="w-100 h-100 flex-row space-around">
      <div>Page is being loaded...</div>
    </div>
  </ng-template>
</div>
